import { useRef, useState } from 'react';

import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { TipoPublicacaoOficial } from '../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';
import useTipoPublicacaoOficialSiteFetch from './useTipoPublicacaoOficialSiteFetch';

type Props = {
  isdisabled?: boolean;
  isLoading?: boolean;
  required?: boolean;
  value?: TipoPublicacaoOficial | null;
  handleSearchChange: (newValue: TipoPublicacaoOficial) => void;
};

const TxtTipoPublicacaoOficialSite = ({ isdisabled, isLoading, required, value, handleSearchChange }: Props) => {
  const timeoutRef = useRef<number | null>(null);
  const loading = useRef(false);

  const handleSetLoad = (newValue: boolean) => {
    loading.current = newValue;
  };

  const [inputValue, setInputValue] = useState('');
  const { options } = useTipoPublicacaoOficialSiteFetch({ inputValue, handleSetLoad });

  return (
    <Autocomplete
      value={value && value.id ? value : null} //
      size="small"
      options={options}
      disabled={isdisabled}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={option => {
        const tipoPublicacaoOficialSite = option as TipoPublicacaoOficial;
        let descricao: string = '';
        if (!tipoPublicacaoOficialSite) {
          return '';
        }

        if (tipoPublicacaoOficialSite.nome) {
          descricao = tipoPublicacaoOficialSite.nome;
        }

        //if (tipoPublicacaoOficialSite.usuario?.cpf) {
        //    descricao = "(" + tipoPublicacaoOficialSite.usuario.cpf + ") " + descricao;
        // }
        return descricao;
        //return tipoPublicacaoOficialSite.descricao ? tipoPublicacaoOficialSite.descricao : "";
      }}
      loading={loading.current}
      onInputChange={(event, newInputValue) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setInputValue(newInputValue);
        }, 700); // 300ms delay
      }}
      onChange={(event, newValue) => {
        handleSearchChange(newValue as TipoPublicacaoOficial);
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Tipo de Publicação Oficial"
          required={required ? true : false}
          disabled={isdisabled ? true : false}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading.current ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};
export default TxtTipoPublicacaoOficialSite;
